'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _passwordValidator = require('../util/passwordValidator');

var _passwordValidator2 = _interopRequireDefault(_passwordValidator);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite.StyleSheet.create({
	mainTitle: {
		margin: 0,
		padding: 0
	},
	createAccountWrapper: {
		padding: '50px'
	},
	createAccountWrapper_small: {
		'@media (max-width: 500px)': {
			padding: '50px 15px'
		}
	},
	blurb: {
		marginTop: '1em'
	},
	itsFreeLine: {
		margin: '30px 0 15px 0'
	},
	passwordWarningWrapper: {
		background: '#fff7f7',
		padding: '10px 10px 5px',
		borderRadius: 5,
		border: '1px solid #c72e2e',
		marginTop: 15
	},
	passwordWarningItem: {
		margin: 0,
		paddingBottom: 5
	},
	passwordHintWrapper: {
		background: '#eef1f6',
		padding: 5,
		borderRadius: 5,
		marginTop: 5,
		fontSize: 12
	},
	legalWrapper: {
		marginTop: '20px',
		position: 'relative'
	},
	legalCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline'
	},
	legalCheckbox: {
		':before': {
			overflow: 'hidden',
			border: '1px solid #9b9b9b'
		}
	},
	redBorder: {
		':before': {
			background: '#fff7f7',
			border: '1px solid #c72e2e'
		}
	},
	legalBlurb: {
		marginLeft: '40px'
	},
	button: {
		display: 'block',
		margin: '40px auto 0'
	},
	passwordWrapper: {
		marginBottom: '10px'
	},
	legalTextOnly: {
		lineHeight: '18px'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none'
	}
});

var CreateAccountPost = function (_React$Component) {
	_inherits(CreateAccountPost, _React$Component);

	function CreateAccountPost(props) {
		_classCallCheck(this, CreateAccountPost);

		var _this = _possibleConstructorReturn(this, (CreateAccountPost.__proto__ || Object.getPrototypeOf(CreateAccountPost)).call(this, props));

		_initialiseProps.call(_this);

		var _props$country = props.country,
		    country = _props$country === undefined ? 'US' : _props$country;

		var countryInfo = (0, _localizer.getCountryInfo)(country);

		_this.state = {
			password1: '',
			password2: '',
			acceptedLegal: false,
			showValidationErrors: false,
			passwordErrors: [],

			occupation: '', // For cross-border
			dateOfBirth: '',
			nationality: '',
			consentCommunication: countryInfo.consentCheckBoxEnabled || false, // For cross-border
			showPasswordHint: false
		};
		return _this;
	}

	/**
 * check that the two passwords within state are matching
 * @return {boolean}
 */


	/**
 * Return dobPattern from specified props or get it from countryInfo
 */


	/**
 * check id date of birth is valid
 * @return {boolean}
 */


	/**
 * check if date of birth is valid
 * @return {string}
 */


	_createClass(CreateAccountPost, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    _props$country2 = _props.country,
			    country = _props$country2 === undefined ? 'US' : _props$country2,
			    supportedCountries = _props.supportedCountries;
			var _state = this.state,
			    showValidationErrors = _state.showValidationErrors,
			    acceptedLegal = _state.acceptedLegal,
			    passwordErrors = _state.passwordErrors,
			    dateOfBirth = _state.dateOfBirth,
			    occupation = _state.occupation,
			    nationality = _state.nationality,
			    occupationError = _state.occupationError,
			    showPasswordHint = _state.showPasswordHint;

			var countryInfo = (0, _localizer.getCountryInfo)(country);

			var passwordErrorsExist = !this.doPasswordsMatch() || !!passwordErrors.length;
			var legalErrorExist = countryInfo.showLegalCheckBox && !acceptedLegal;
			var dateOfBirthErrorsExist = countryInfo.showDOB && !dateOfBirth;
			var dateOfBirthInvalidExist = countryInfo.showDOB && dateOfBirth && !(0, _localizer.validateDob)(dateOfBirth, this.getDobPattern());
			var occupationErrorsExist = countryInfo.showOccupation && !occupation;
			var nationalityErrorsExist = countryInfo.showNationality && !nationality;
			var shouldShowErrorMessages = showValidationErrors && (passwordErrorsExist || legalErrorExist || dateOfBirthErrorsExist || dateOfBirthInvalidExist || occupationErrorsExist || nationalityErrorsExist);

			return _react2.default.createElement(
				'div',
				{ style: _extends({}, _styles2.default.generalWrapper, _styles2.default.PrimaryFontFamily, !this.props.shouldShowBorder && { border: 'none' }) },
				_react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(styles.createAccountWrapper, styles.createAccountWrapper_small) },
					_react2.default.createElement(
						'h2',
						{ className: (0, _aphrodite.css)(styles.mainTitle) },
						this.props.mainTitle
					),
					_react2.default.createElement(
						'p',
						{ className: (0, _aphrodite.css)(styles.blurb) },
						this.props.mainBlurb
					),
					_react2.default.createElement(
						'p',
						{ className: (0, _aphrodite.css)(styles.itsFreeLine) + ' vx_text-5' },
						this.props.itsFreeLine
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, {
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.label1,
							name: 'password1',
							type: 'password',
							id: 'password1',
							handleMouseOut: function handleMouseOut() {
								return _this2.hidePasswordHint(countryInfo.showPasswordHint);
							},
							handleBlur: function handleBlur() {
								return _this2.hidePasswordHint(countryInfo.showPasswordHint);
							},
							handleChange: function handleChange(password) {
								return _this2.handleUpdatePasswords(password, 'password1', countryInfo.showPasswordHint);
							}
						}),
						showPasswordHint && countryInfo.showPasswordHint && _react2.default.createElement(
							'div',
							{ id: 'password_hint', className: (0, _aphrodite.css)(styles.passwordHintWrapper) },
							this.props.passwordWarnings._HINT1 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT1
							),
							this.props.passwordWarnings._HINT2 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT2
							),
							this.props.passwordWarnings._HINT3 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT3
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, {
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.label2,
							name: 'password2',
							type: 'password',
							id: 'password2',
							handleChange: function handleChange(password) {
								return _this2.handleUpdatePasswords(password, 'password2');
							}
						})
					),
					countryInfo.showDOB && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.dobWrapper), { 'vx_has-error': showValidationErrors && dateOfBirthErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, { type: 'tel',
							id: 'dateOfBirth',
							name: 'dateOfBirth',
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.labeldob,
							autocomplete: 'off',
							helpText: this.getDobPattern(),
							handleChange: function handleChange(date) {
								return _this2.handleChangeDob(date);
							} })
					),
					countryInfo.showOccupation && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)({ 'vx_has-error': showValidationErrors && occupationError }),
							style: { paddingTop: 0, margin: '10px 0 0', position: 'relative' } },
						_react2.default.createElement(
							'select',
							{ name: 'occupation', id: 'occupation',
								className: 'vx_form-control ' + (0, _aphrodite.css)(styles.dropdown),
								value: this.state.occupation,
								onChange: function onChange(value) {
									return _this2.handleChangeOccupation(value);
								},
								style: styles.dropdown },
							_react2.default.createElement(
								'option',
								{ value: '', disabled: true },
								this.props.labelocc
							),
							countryInfo.occupations.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ key: item.label, value: item.label },
									item.label
								);
							})
						),
						_react2.default.createElement('label', { htmlFor: this.props.labelocc, className: 'icon icon-arrow-down-small', style: {
								position: 'absolute', right: 10, top: '50%', cursor: 'default', pointerEvents: 'none' } })
					),
					countryInfo.showNationality && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)({ 'vx_has-error': showValidationErrors && occupationError }),
							style: { paddingTop: 0, margin: '10px 0 0', position: 'relative' } },
						_react2.default.createElement(
							'select',
							{ name: 'nationality', id: 'nationality',
								className: 'vx_form-control ' + (0, _aphrodite.css)(styles.dropdown),
								value: this.state.nationality,
								onChange: function onChange(value) {
									return _this2.handleChangeNationality(value);
								},
								style: styles.dropdown },
							_react2.default.createElement(
								'option',
								{ value: '', disabled: true },
								this.props.labelnationality
							),
							supportedCountries.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ key: item.countryCode, value: item.countryCode },
									item.countryName
								);
							})
						),
						_react2.default.createElement('label', { htmlFor: this.props.labelocc, className: 'icon icon-arrow-down-small', style: {
								position: 'absolute', right: 10, top: '50%', cursor: 'default', pointerEvents: 'none' } })
					),
					shouldShowErrorMessages && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.passwordWarningWrapper) },
						showValidationErrors && passwordErrorsExist && this.renderPasswordErrors(),
						showValidationErrors && dateOfBirthErrorsExist && _react2.default.createElement(
							'p',
							{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
							this.props.passwordWarnings._REQUIRED_DOB
						),
						showValidationErrors && dateOfBirthInvalidExist && _react2.default.createElement(
							'p',
							{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
							this.props.passwordWarnings._INVALID_DOB
						),
						showValidationErrors && occupationErrorsExist && _react2.default.createElement(
							'p',
							{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
							this.props.passwordWarnings._OCCUPATION
						),
						showValidationErrors && nationalityErrorsExist && _react2.default.createElement(
							'p',
							{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
							this.props.passwordWarnings._NATIONALITY
						),
						showValidationErrors && legalErrorExist && _react2.default.createElement(
							'p',
							{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
							this.props.passwordWarnings._LEGAL_CHECKBOX
						)
					),
					countryInfo.showLegalTextOnly && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalTextOnly) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.legalOnlyHTML } })
					),
					countryInfo.showLegalCheckBox && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.legalCheckboxWrapper)) },
							_react2.default.createElement('input', {
								onChange: this.handleLegalCheckbox,
								type: 'checkbox', id: 'accountLegalCheckbox' }),
							_react2.default.createElement('label', { htmlFor: 'accountLegalCheckbox', className: (0, _aphrodite.css)(styles.legalCheckbox, showValidationErrors && !acceptedLegal && styles.redBorder) })
						),
						_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalBlurb) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.legalBlurbHTML } })
					),
					countryInfo.showConsentCheckBox && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.legalCheckboxWrapper)) },
							_react2.default.createElement('input', {
								checked: this.state.consentCommunication,
								onChange: this.handleConsentCheckbox,
								type: 'checkbox', id: 'consentCheckbox' }),
							_react2.default.createElement('label', { htmlFor: 'consentCheckbox' })
						),
						_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalBlurb) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.consentBlurbHTML } })
					),
					_react2.default.createElement(
						'button',
						{
							type: 'button',
							onClick: this.handleButtonClick,
							className: (0, _classnames2.default)('vx_btn', (0, _aphrodite.css)(styles.button)) },
						this.props.buttonText
					)
				)
			);
		}
	}]);

	return CreateAccountPost;
}(_react2.default.Component);

CreateAccountPost.propTypes = {
	handleSubmit: _propTypes2.default.func.isRequired,
	mainTitle: _propTypes2.default.string.isRequired,
	mainBlurb: _propTypes2.default.string.isRequired,
	itsFreeLine: _propTypes2.default.string.isRequired,
	label1: _propTypes2.default.string.isRequired,
	label2: _propTypes2.default.string.isRequired,
	legalBlurbHTML: _propTypes2.default.string.isRequired,
	buttonText: _propTypes2.default.string.isRequired,
	passwordWarnings: _propTypes2.default.shape({
		_MISMATCH: _propTypes2.default.string.isRequired,
		_IS_NULL: _propTypes2.default.string.isRequired,
		_TOO_SHORT: _propTypes2.default.string.isRequired,
		_TOO_LONG: _propTypes2.default.string.isRequired,
		_CONTAINS_REPEATED_CHARACTERS: _propTypes2.default.string.isRequired,
		_CONTAINS_NUMBER_SEQUENCE: _propTypes2.default.string.isRequired,
		_CONTAINS_LETTER_SEQUENCE: _propTypes2.default.string.isRequired,
		_CONTAINS_NUMBER_LETTER_SEQUENCE: _propTypes2.default.string.isRequired,
		_IS_BLACKLISTED: _propTypes2.default.string.isRequired,
		_CONTAINS_SPACES: _propTypes2.default.string.isRequired,
		_HAS_ILLEGAL_CHARACTERS: _propTypes2.default.string.isRequired,
		_LEGAL_CHECKBOX: _propTypes2.default.string.isRequired,
		_REQUIRED_DOB: _propTypes2.default.string,
		_INVALID_DOB: _propTypes2.default.string,
		_OCCUPATION: _propTypes2.default.string,
		_NATIONALITY: _propTypes2.default.string,
		_HINT1: _propTypes2.default.string,
		_HINT2: _propTypes2.default.string,
		_HINT3: _propTypes2.default.string
	}).isRequired,
	dobPattern: _propTypes2.default.string,
	country: _propTypes2.default.string,
	labeldob: _propTypes2.default.string,
	labelocc: _propTypes2.default.string,
	labelnationality: _propTypes2.default.string,
	legalOnlyHTML: _propTypes2.default.string,
	consentBlurbHTML: _propTypes2.default.string,
	supportedCountries: _propTypes2.default.array,
	shouldShowBorder: _propTypes2.default.bool.isRequired
};
CreateAccountPost.defaultProps = {
	shouldShowBorder: true
};

var _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.handleUpdatePasswords = function (password, whichInput, hasPasswordHint) {
		var _newState;

		var newState = (_newState = {}, _defineProperty(_newState, whichInput, password), _defineProperty(_newState, 'showPasswordHint', hasPasswordHint), _defineProperty(_newState, 'passwordErrors', whichInput === 'password1' ? (0, _passwordValidator2.default)(password) : _this3.state.passwordErrors), _newState);
		_this3.setState(newState);
		return password; // returning for TextInput https://github.paypal.com/react/react-text-input
	};

	this.hidePasswordHint = function (isHint) {
		if (isHint) {
			_this3.setState({ showPasswordHint: false });
		}
	};

	this.handleLegalCheckbox = function (event) {
		_this3.setState({
			acceptedLegal: event.target.checked
		});
	};

	this.doPasswordsMatch = function () {
		return _this3.state.password1 === _this3.state.password2;
	};

	this.getDobPattern = function () {
		if (_this3.props.dobPattern) {
			return _this3.props.dobPattern;
		}

		var _props$country3 = _this3.props.country,
		    country = _props$country3 === undefined ? 'US' : _props$country3;

		var countryInfo = (0, _localizer.getCountryInfo)(country);
		return countryInfo.DOBPattern;
	};

	this.validateDateOfBirth = function () {
		return (0, _localizer.validateDob)(_this3.state.dateOfBirth, _this3.getDobPattern());
	};

	this.handleChangeDob = function (date) {
		var dateOfBirth = (0, _localizer.getFormattedDob)(date, _this3.getDobPattern());

		_this3.setState({ dateOfBirth: dateOfBirth });
		return dateOfBirth;
	};

	this.handleChangeOccupation = function (event) {
		var occupation = event.target.value;
		_this3.setState({ occupation: occupation });
		return occupation;
	};

	this.handleChangeNationality = function (event) {
		var nationality = event.target.value;
		_this3.setState({ nationality: nationality });
		return nationality;
	};

	this.handleConsentCheckbox = function (event) {
		var consentCommunication = event.target.checked;
		_this3.setState({
			consentCommunication: consentCommunication
		});
		return consentCommunication;
	};

	this.handleButtonClick = function () {
		var _ref = {},
		    _ref$passwordValid = _ref.passwordValid,
		    passwordValid = _ref$passwordValid === undefined ? true : _ref$passwordValid,
		    _ref$dobValid = _ref.dobValid,
		    dobValid = _ref$dobValid === undefined ? true : _ref$dobValid,
		    _ref$occValid = _ref.occValid,
		    occValid = _ref$occValid === undefined ? true : _ref$occValid,
		    _ref$legalValid = _ref.legalValid,
		    legalValid = _ref$legalValid === undefined ? true : _ref$legalValid,
		    _ref$natValid = _ref.natValid,
		    natValid = _ref$natValid === undefined ? true : _ref$natValid;
		var _props$country4 = _this3.props.country,
		    country = _props$country4 === undefined ? 'US' : _props$country4;
		var _state2 = _this3.state,
		    password1 = _state2.password1,
		    acceptedLegal = _state2.acceptedLegal,
		    dateOfBirth = _state2.dateOfBirth,
		    occupation = _state2.occupation,
		    nationality = _state2.nationality,
		    consentCommunication = _state2.consentCommunication;

		var passwordErrors = (0, _passwordValidator2.default)(password1);
		var countryInfo = (0, _localizer.getCountryInfo)(country);

		var userData = { password: password1 };
		passwordValid = _this3.doPasswordsMatch() && !passwordErrors.length;

		if (countryInfo.showLegalCheckBox) {
			userData.legalValid = acceptedLegal;
			legalValid = !!acceptedLegal;
		}

		if (countryInfo.showDOB) {
			userData.dateOfBirth = dateOfBirth;
			userData.dateOfBirthPattern = _this3.getDobPattern();
			dobValid = (0, _localizer.validateDob)(dateOfBirth, userData.dateOfBirthPattern);
		}

		if (countryInfo.showOccupation) {
			userData.occupation = occupation;
			occValid = !!occupation;
		}

		if (countryInfo.showNationality) {
			userData.nationality = nationality;
			natValid = !!nationality;
		}

		if (countryInfo.showConsentCheckBox) {
			userData.consentCommunication = consentCommunication;
		}

		if (passwordValid && legalValid && dobValid && occValid && natValid) {
			_this3.props.handleSubmit(userData);
		} else {
			_this3.setState({
				showValidationErrors: true,
				passwordErrors: passwordErrors
			});
		}
	};

	this.renderPasswordErrors = function () {
		return _react2.default.createElement(
			'span',
			null,
			!_this3.doPasswordsMatch() && _react2.default.createElement(
				'p',
				{ className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
				_this3.props.passwordWarnings._MISMATCH
			),
			_this3.state.passwordErrors.map(function (code) {
				var warningMessage = _this3.props.passwordWarnings[code];
				return _react2.default.createElement(
					'p',
					{ key: code, className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
					warningMessage
				);
			})
		);
	};
};

exports.default = CreateAccountPost;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/CreateAccountPost.js
// module id = 698
// module chunks = 5